import { WebExterna, ContenidoWebExternaIdiomaFormulario } from './../domain/WebExterna';

import { Component, Input, EventEmitter, Output, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { ServiciosWebServiceProvider } from '../providers/web-service-service/servicios-web-service';
import { AuthenticationService } from '../providers/authentication/authentication.service';
import { TranslateService } from 'ng2-translate';
import { IdiomaService } from '../providers/idioma/idioma.service';
import { Idioma } from '../domain/Idioma';
import { emit } from 'cluster';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-formulario-web-externa',
  templateUrl: './FormularioWebExterna.component.html'
})

export class FormularioWebExternaComponent implements OnDestroy, OnChanges{

	@Input() WebExternaSeleccionada: WebExterna;

	@Output() onElementoGuardado: EventEmitter<any> = new EventEmitter();
	@Output() onElementoError: EventEmitter<any> = new EventEmitter();
	@Output() onElementoEliminado: EventEmitter<boolean> = new EventEmitter();

	public msgsValidacion;
	public confirmacionVisible;
	public operacion;

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;

	constructor(
		private appComponent: AppComponent,
		private entityManager: EntityManagerProvider,
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		public translate: TranslateService,
		private idiomaService: IdiomaService
	) {
		const that = this;
		this.entityManager.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {

			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;

			if (that.WebExternaSeleccionada) {
				that.WebExternaSeleccionada.Idiomas = that.idiomaService.newMapContenidoWebExternaIdiomas(that.idiomas);
			}
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.idiomaSeleccionado = this.idiomaDefecto;
		this.confirmacionVisible = false;
		this.onIdiomaChange({value: this.idiomaSeleccionado});
	}

	ngOnDestroy(): void {
		this.entityManager.RejectChanges();
	}

	/* ACCIONES */
	guardarContenidoWebExterna() {

		if (this.validar()) {
			// if (this.esEdicion() === false) {
				// Delegamos la guardado de la web a NuevoContenidoComponent pera no cambiar esa logica ahoramismo
			this.onElementoGuardado.emit(this.WebExternaSeleccionada);
			this.authService.relogin();
			// }
		}
	}

	eliminarContenidoWebExterna(webSeleccionada) {
		// Delegamos la eliminacion de la web a NuevoContenidoComponent pera no cambiar esa logica ahoramismo
		this. onElementoEliminado.emit(webSeleccionada);
		this.authService.relogin();
	}


	/* ************************************************************************** */
	/*                            COMUN FORMULARIO                                */
	/* ************************************************************************** */

	/*  */
	public esEdicion(): boolean {
		return this.WebExternaSeleccionada && (this.WebExternaSeleccionada.ENTIDAD ? true : false);
	}

	inputChanged(value) {

		//  Cojemos la traduccion del contenido al idioma seleccionado
		if (this.WebExternaSeleccionada) {
			const contenidoWebExternaIdioma = this.WebExternaSeleccionada.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);
			// Guardamos los posibles cambios del idioma
			if (contenidoWebExternaIdioma) {
				contenidoWebExternaIdioma.Texto = this.WebExternaSeleccionada.Nombre;
				this.WebExternaSeleccionada.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, contenidoWebExternaIdioma);
			}
		}
	}

	public validar(): boolean {
		console.warn('Implementar: validar');
		return true;
	}

	public guardar(): any {
		if (this.esEdicion()) {
			return this.guardarEdicion();
		}
		else{
			return this.guardarNuevo();
		}

	}

	public guardarNuevo(){
		const that = this;
	}

	guardarEdicion(){

	}


	public subirImagenTipologiaSeleccionada(imagenTipologiaSeleccionada) {

	}

	/* IDIOMA */
	onIdiomaChange($event) {
		const idioma = $event.value;
		if (!idioma || !this.WebExternaSeleccionada || !this.WebExternaSeleccionada.Idiomas) {
			return;
		}
		this.idiomaSeleccionado = idioma;

		// Cojemos la traduccion del espacio al idioma seleccionado
		let contenidoWebExternaIdioma = this.WebExternaSeleccionada.Idiomas.get(idioma.value);
		// Si no existe la creamos
		if (!contenidoWebExternaIdioma) {
			contenidoWebExternaIdioma = new ContenidoWebExternaIdiomaFormulario();
			this.WebExternaSeleccionada.Idiomas.set(idioma.value, contenidoWebExternaIdioma);
		}


		// Seteamos los valores de espacioFormulario con los valores del idioma seleccionado
		this.WebExternaSeleccionada.Nombre = contenidoWebExternaIdioma.Texto;

		console.log('Cambiado el Titulo al del idioma: ' + idioma.value + '(' + idioma.title + ')');
	}

	/* Confirmacion */
	mostrarConfirmacion(operacion){
		this.appComponent.showWarn(operacion);
		this.operacion = operacion;
		this.confirmacionVisible = true;
	}

	confirmar(){
		this.confirmacionVisible = false;
		this.msgsValidacion = [];

		if (this.operacion === 'guardar') {
			this.guardarContenidoWebExterna();
		}
		else if (this.operacion === 'eliminar'){
			this.eliminarContenidoWebExterna(this.WebExternaSeleccionada);
		}
	}

	cancelar(){
		this.msgsValidacion = [];
		this.operacion = '';
		this.confirmacionVisible = false;
	}

	showWarn(operacion) {
		this.msgsValidacion = [];
		if (operacion === 'guardar') {
			this.msgsValidacion.push({severity: 'warn', detail: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_MODIFICAR')});
		}
		else if (operacion === 'eliminar'){
			this.msgsValidacion.push({severity: 'warn', detail: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_ELIMINAR')});
		}
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioWebExterna.component.ts